import colors from 'globals/colors'
import styled from 'styled-components'
import measures from 'globals/measures'

export const ClientValidationWrapper = styled.div`
  padding-top: 15px;
  height: 550px;
  overflow-y: auto;
`

export const DocumentsList = styled.div`
  width: 100%;
  max-width: 388px;
  background: ${colors.footerColor};
  border-radius: 4px;
  padding: 28px 32px;
  display: flex;
  flex-direction: column;
  
  & > b {
    line-height: 19px;
    font-weight: 600;
    margin-bottom: 17px;
  }
`

export const DocumentWrapper = styled.div`
  line-height: 30px;
  display: flex;
  align-items: center;
  
  & svg {
    margin-right: 16px;
    margin-bottom: -2px;
  }
  
  & svg .color-stroke {
    stroke: ${colors.darkGrey} !important;
  }
`

export const DownloadLink = styled.a`
  line-height: 19px;
  font-weight: 600;
  text-decoration: underline;
  margin-top: 34px;
  display: flex;
  align-items: center;
  
  & svg {
    margin-right: 10px;
  }
  
  @media (max-width: ${measures.mobileThreshold}px) {
    align-items: flex-start;
    
    & svg {
      position: relative;
      top: 3px;
    }
  }
`

export const ValidateClient = styled.div`
  line-height: 19px;
  margin-top: 35px;
  
  & > b {
    font-weight: 600;
    margin-bottom: 20px;
    display: block;
  }
  
  & textarea {
    width: 100%;
    max-width: 388px;
  }
  
  & button {
    width: 100%;
    max-width: 250px;
    margin-top: 8px;
    
    @media (max-width: ${measures.mobileThreshold}px) {
      max-width: 100%;
    }
  }
`

export const ValidationChoices = styled.div`
  display: flex;
  
  & .ant-radio-wrapper {
    font-weight: 600;
    color: ${colors.steelGrey};
    margin-right: 25px;
    
    &.ant-radio-wrapper-checked {
      color: ${colors.darkGrey};
    }
  }
`

interface ConfirmationMessageProps {
  validated: boolean
}

export const ConfirmationMessage = styled.div<ConfirmationMessageProps>`
  line-height: 19px;
  color: ${(props) => props.validated ? colors.blueGreen : colors.reddishPink};
  margin-top: 6px;
`
